<template>
  <div class="container">
    <div class="columns">
      <div class="column is-6">
        <LsSupportHeader label="Change My Pro" back-route="changeMyProvider" />
      </div>
    </div>
    <div class="columns">
      <main class="column is-6">
        <LsIcon type="exclamation" color="danger" size="lg" />
        <h4>Something went wrong!</h4>
        <p>We are unable to process your change pro request. Please try again in a few minutes.</p>
        <LsButton
          class="back"
          text="Try Again"
          track-id="change_my_pro-try_again"
          bg-color="primary"
          @click="$router.push({ name: 'changeMyProvider' })"
        />
      </main>
    </div>
  </div>
</template>

<script>
import { LsSupportHeader } from '../components';
import { LsButton, LsIcon } from '@/components/common';

export default {
  name: 'ChangeProFail',
  components: { LsSupportHeader, LsButton, LsIcon },
};
</script>

<style lang="scss" scoped>
h4 {
  font-size: 1.8rem;
  color: $theme-color-danger;
  margin-top: 1rem;
  & ~ p {
    margin: 1rem 0 3rem 0;
  }
}
@media (max-width: $mobile-max-width) {
  h4 {
    text-align: center;
    & ~ p {
      text-align: center;
    }
  }
  main {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
}
</style>
